import momentTimezone from 'moment-timezone';
import React, {memo, useContext, useMemo} from 'react';
import {useIntl} from 'react-intl';
import {ThemeContext} from '../../apiContexts';
import ReactTable from '../../components/reactTable';
import {convertDistanceTo, convertVolumeTo, nomenclatureDistance, nomenclatureVolume} from '../../helpers/conversions';
import {durationFormat} from '../../helpers/date';
import {getColumnWidth} from '../../helpers/report';
import {Header, ListStyle} from './styles';
import LoadingBar from '../../components/loadingBar';
import SelectDeviceButton from './selectDeviceButton';

const StopList = ({
  className,
  data,
  timezone,
  onSelect,
  speedUnit,
  distanceUnit,
  volumeUnit,
  loading,
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const intl = useIntl();

  const columns = useMemo(
      () => [
        {
          Header: intl.formatMessage({id: 'sharedName'}),
          accessor: 'deviceName',
          minWidth: 200,
          width: getColumnWidth(data, 'deviceName', intl.formatMessage({id: 'sharedName'})),
        },
        {
          Header: intl.formatMessage({id: 'reportStartTime'}),
          accessor: 'startTime',
          Cell: ({cell: {value}}) =>
            momentTimezone(value)
                .tz(timezone)
                .format(intl.formatMessage({id: 'dateTimeLongFormat'})),
          minWidth: 200,
        },
        {
          Header: intl.formatMessage({id: 'reportStartOdometer'}),
          accessor: 'startOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: intl.formatMessage({id: 'sharedAddress'}),
          accessor: 'address',
          Cell: ({cell: {value}}) => value || '-',
          minWidth: 150,
          width: getColumnWidth(data, 'address', intl.formatMessage({id: 'sharedAddress'})),
        },
        {
          Header: intl.formatMessage({id: 'reportEndTime'}),
          accessor: 'endTime',
          Cell: ({cell: {value}}) =>
            momentTimezone(value)
                .tz(timezone)
                .format(intl.formatMessage({id: 'dateTimeLongFormat'})),
          minWidth: 200,
        },
        {
          Header: intl.formatMessage({id: 'reportDuration'}),
          accessor: 'duration',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: intl.formatMessage({id: 'reportEngineHours'}),
          accessor: 'engineHours',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: intl.formatMessage({id: 'reportSpentFuel'}),
          accessor: 'spentFuel',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertVolumeTo(value, volumeUnit)).toFixed(1) ||
            0} ${nomenclatureVolume(volumeUnit)}`,
        },
      ],
      [data, distanceUnit, timezone, volumeUnit],
  );

  const selectItem = (props) => onSelect(props);

  return (
    <ListStyle theme={theme} className="custom-shadow-2">
      <Header>
        <h5>{intl.formatMessage({id: 'stopHistory'})}</h5>
        <SelectDeviceButton />
      </Header>
      {loading ? (
        <LoadingBar />
      ) : (
        <ReactTable data={data} columns={columns} selectItem={selectItem} />
      )}
    </ListStyle>
  );
};

export default memo(StopList);
